((root, factory) => {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.CorkopiaIntelligenceLayer = api;
})(typeof globalThis !== 'undefined' ? globalThis : window, () => {
  'use strict';

  const STAGES = Object.freeze([
    'input',
    'validation',
    'rules',
    'eligibility',
    'ranking',
    'recommendation',
    'explanation',
    'actions',
    'events',
    'logging'
  ]);

  const execute = ({ request, handlers = {} }) => {
    const context = { request };
    const stageResults = [];
    let blockedBy = '';

    STAGES.forEach((stage, index) => {
      if (blockedBy) {
        stageResults.push({
          stage,
          sequence: index + 1,
          status: 'empty',
          codes: [`BLOCKED_BY_${blockedBy.toUpperCase()}`]
        });
        return;
      }

      try {
        const output = typeof handlers[stage] === 'function'
          ? handlers[stage](Object.freeze({ ...context }))
          : {};
        const value = output?.value ?? output;
        const status = output?.status || (value === null ? 'empty' : 'complete');
        const codes = Array.isArray(output?.codes) ? output.codes : [];
        context[stage] = value;
        stageResults.push({ stage, sequence: index + 1, status, codes });
        if (status === 'failed') blockedBy = stage;
      } catch (error) {
        context[stage] = null;
        stageResults.push({
          stage,
          sequence: index + 1,
          status: 'failed',
          codes: [String(error?.code || 'PIPELINE_STAGE_FAILED')]
        });
        blockedBy = stage;
      }
    });

    return {
      context,
      stages: stageResults,
      complete: stageResults.every((stage) => ['complete', 'empty'].includes(stage.status))
    };
  };

  return Object.freeze({ STAGES, execute });
});
